import { render, staticRenderFns } from "./add-product-category.vue?vue&type=template&id=4f12216d&scoped=true"
import script from "./add-product-category.vue?vue&type=script&lang=js"
export * from "./add-product-category.vue?vue&type=script&lang=js"
import style0 from "./add-product-category.vue?vue&type=style&index=0&id=4f12216d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12216d",
  null
  
)

export default component.exports